'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    // 브라우저 언어 감지
    const browserLang = navigator.language.toLowerCase();
    
    // 한국어면 ko, 아니면 en
    const locale = browserLang.startsWith('ko') ? 'ko' : 'en';
    
    // 해당 언어 페이지로 리다이렉트
    router.replace(`/${locale}`);
  }, [router]);

  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Pretendard Variable, Inter, sans-serif'
    }}>
      Loading...
    </div>
  );
}